import { apiClient } from "./client";

async function post(url, body) {
  const res = await apiClient.post(url, body);
  return res.data;
}

export const getOrderTypes = (id, dateFrom, dateTo) => post("/dash/reports/order-types", { id, dateFrom, dateTo });
export const getOrderOrigins = (id, dateFrom, dateTo) => post("/dash/reports/order-origins", { id, dateFrom, dateTo });
export const getPulse = (id) => post("/dash/reports/pulse", { id });
export const getTopDishesToday = (id) => post("/dash/reports/top-dishes-today", { id });
export const getTodayAlerts = (id) => post("/dash/reports/today-alerts", { id });
export const getCostMargin = (id, dateFrom, dateTo) => post("/dash/reports/cost-margin", { id, dateFrom, dateTo });
export const getMenuMatrix = (id, dateFrom, dateTo) => post("/dash/reports/menu-matrix", { id, dateFrom, dateTo });
export const getDaypart = (id, dateFrom, dateTo) => post("/dash/reports/daypart", { id, dateFrom, dateTo });
export const getDiscountEffectiveness = (id, dateFrom, dateTo) =>
  post("/dash/reports/discount-effectiveness", { id, dateFrom, dateTo });
export const getPromotionsReport = (id, dateFrom, dateTo) =>
  post("/dash/reports/promotions", { id, dateFrom, dateTo });
export const getStockBalances = (id) => post("/dash/reports/stock-balances", { id });
export const getStockDepletion = (id) => post("/dash/reports/stock-depletion", { id });
export const getStockAnomalies = (id) => post("/dash/reports/stock-anomalies", { id });
export const getPurchaseRiskList = (id) => post("/dash/reports/purchase-risk-list", { id });
export const getInventoryAudit = (id, dateFrom, dateTo) =>
  post("/dash/reports/inventory-audit", { id, dateFrom, dateTo });
export const getSalesForecast = (id, city, days) => post("/dash/reports/sales-forecast", { id, city, days });
export const compareServers = (ids, dateFrom, dateTo) => post("/dash/reports/compare-servers", { ids, dateFrom, dateTo });
